import { format, isWithinInterval } from 'date-fns'
import { getExcel } from './exportExcel'

interface DebinPayment {
  id: string
  activityData: {
    text: string
  }
  date: string,
  amount: number
  concept: string
}

export const downloadDebinExcel = (
  data: DebinPayment[],
  dateFrom: Date,
  dateTo: Date
) => {
  const filteredData = data.filter(item =>
    isWithinInterval(new Date(item.date), {
      start: dateFrom,
      end: dateTo
    })
  )

  if (filteredData.length === 0) {
    console.warn('No hay datos para exportar en el rango seleccionado')
    return
  }

  const excelData = {
    header: ['Actividad', 'Fecha', 'Monto', 'Concepto'],
    properties: ['activityData.text', 'date', 'amount', 'concept'],
    array: filteredData
  }

  const dateFromStr = format(dateFrom, 'dd-MM-yyyy')
  const dateToStr = format(dateTo, 'dd-MM-yyyy')

  getExcel(excelData, `Pagos-DEBIN_${dateFromStr}_${dateToStr}`)
}
